export const PropChangeContextType = {
    COMMON: 'common',
    DATASET: 'dataset',
};

export class PropChangeContext {
    prop;
    type;
    details = null;

    constructor({ prop, type = PropChangeContextType.COMMON, details = null } = {}) {
        this.prop = prop;
        this.type = type;
        this.details = details;
    }
}